import {isRTL} from '../../../../../../Localization';
import {languageTabs} from './constants';

export const getLanguageTabs = () => {
    return isRTL() ? [...languageTabs].reverse() : languageTabs;
};
